type JwtPayload = {
  sub: string;
  email: string;
  role: "admin" | "teacher";
  exp?: number;
  iat?: number;
  iss?: string;
};

function base64UrlDecode(str: string): string {
  const padded = str.replace(/-/g, "+").replace(/_/g, "/");
  const withPadding = padded.padEnd(
    padded.length + ((4 - (padded.length % 4)) % 4),
    "=",
  );
  return atob(withPadding);
}

export function decodeJwtPayload(token: string): JwtPayload {
  const parts = token.split(".");
  const payloadPart = parts[1];
  if (!payloadPart) {
    throw new Error("JWT invalide : payload manquant");
  }
  return JSON.parse(base64UrlDecode(payloadPart)) as JwtPayload;
}

export function parseHashParams(hash: string): Record<string, string> {
  const cleaned = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!cleaned) return {};
  const params = new URLSearchParams(cleaned);
  const result: Record<string, string> = {};
  for (const [key, value] of params) {
    result[key] = value;
  }
  return result;
}
